import React, { createContext, useEffect, useMemo } from 'react';
import { useContext } from '..';
import { mapWalletClient, type Wallet } from '../../actions/mapWalletClient';
import { useConnections } from '../../hooks/useConnections';
import { useMutation } from '../../hooks/useMutation';

type ContextValue = {
  wallets: Wallet[];
};

export const Web3Context = createContext<ContextValue | null>(null);

export const Web3Provder = ({ children }: React.PropsWithChildren) => {
  const connections = useConnections();
  const { config } = useContext();

  const { data: wallets, mutate: connectionMutate } = useMutation(mapWalletClient);

  useEffect(() => {
    connectionMutate({ connections, config });
  }, [connections]);

  return (
    <Web3Context.Provider value={useMemo(() => ({ wallets: wallets ?? [] }), [wallets])}>
      {children}
    </Web3Context.Provider>
  );
};

export const useWeb3Context = () => {
  const context = React.useContext(Web3Context);
  if (!context) throw Error('Web3 Hook must be inside a Provider.');
  return context;
};
